module.exports = __webpack_public_path__ + "static/media/www.140c029b.jpg";